// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentResponse {
    static getAttributeTypeMap() {
        return EnrollmentResponse.attributeTypeMap;
    }
}
EnrollmentResponse.discriminator = undefined;
EnrollmentResponse.additionalProperties = false;
EnrollmentResponse.attributeTypeMap = [
    {
        "name": "accountId",
        "baseName": "accountId",
        "type": "number"
    },
    {
        "name": "pharamacyMemberNumber",
        "baseName": "pharamacyMemberNumber",
        "type": "string"
    },
    {
        "name": "medicalMemberNumber",
        "baseName": "medicalMemberNumber",
        "type": "string"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "maxBenefitAmount",
        "baseName": "maxBenefitAmount",
        "type": "number"
    },
    {
        "name": "untrackedBenefit",
        "baseName": "untrackedBenefit",
        "type": "boolean"
    },
    {
        "name": "startDate",
        "baseName": "startDate",
        "type": "Date"
    },
    {
        "name": "endDate",
        "baseName": "endDate",
        "type": "Date"
    },
    {
        "name": "claimEligibilityDate",
        "baseName": "claimEligibilityDate",
        "type": "Date"
    },
    {
        "name": "reenrollmentEligibilityDate",
        "baseName": "reenrollmentEligibilityDate",
        "type": "Date"
    },
    {
        "name": "isOptedIn",
        "baseName": "isOptedIn",
        "type": "boolean"
    },
    {
        "name": "pharmacyMemberNumberDetails",
        "baseName": "pharmacyMemberNumberDetails",
        "type": "MemberNumberDetails"
    },
    {
        "name": "medicalMemberNumberDetails",
        "baseName": "medicalMemberNumberDetails",
        "type": "MemberNumberDetails"
    },
    {
        "name": "enrollmentId",
        "baseName": "enrollmentId",
        "type": "number"
    },
    {
        "name": "enrollmentStatus",
        "baseName": "enrollmentStatus",
        "type": "string"
    },
    {
        "name": "queuedProcessingDate",
        "baseName": "queuedProcessingDate",
        "type": "Date"
    },
];
//# sourceMappingURL=enrollmentResponse.js.map